import * as React from 'react';
import { connect } from 'react-redux';
import { getEnabledDocuments, getRelevantDocuments } from 'Utility/randomUtil';

type Props = IStateFromProps & IOwnProps;

/**
 * Inject one, or array of children with documents loaded from redux state
 */
class DocumentLoader extends React.Component<Props> {
  public render(): React.JSX.Element | React.JSX.Element[] {
    if (Array.isArray(this.props.children)) {
      return this.props.children.map(child =>
        React.createElement(child, { documents: this.props.documents, name: this.props.name }, null),
      );
    } else {
      return React.createElement(this.props.children, { documents: this.props.documents, name: this.props.name });
    }
  }
}

interface IStateFromProps {
  documents: IDocumentV2[];
}

const mapStateToProps = (state: IState, props: IOwnProps): IStateFromProps => {
  const enabledName = getEnabledDocuments(state.session).find(({ name }) => name === props.name);
  const docArray = getRelevantDocuments(state.documents.sortedAndMergedDocuments ?? [], enabledName, props.name);
  return { documents: docArray };
};

interface IOwnProps {
  name: string;
  children:
    | Array<({ documents }: { documents: IDocumentV2[]; name: string }) => React.JSX.Element>
    | (({ documents }: { documents: IDocumentV2[]; name: string }) => React.JSX.Element);
}

export default connect(mapStateToProps)(DocumentLoader);
